const config = {
  API_BASE: 'https://ls-mamta.replit.app/api',
  SENDGRID_API_KEY: 'SG.XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX' // Replace with your actual SendGrid API key
};

export default config; 